/* eslint-disable prettier/prettier */
import { is, getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import cmdHelper from "bpmn-js-properties-panel/lib/helper/CmdHelper";
import elementHelper from "bpmn-js-properties-panel/lib/helper/ElementHelper";
import utils, { escapeHTML } from "bpmn-js-properties-panel/lib/Utils";
import domify from "domify";
import $ from "jquery";
import filter from "lodash/filter";
import forEach from "lodash/forEach";
import { query as domQuery, closest as domClosest } from "min-dom";
import React from "react";
import { createRoot } from "react-dom/client";
import { v4 as uuid } from "uuid";

import ModelerModalCopyField from "./modeler-modal-copy-fields2";
import ModelerModalDeleteForm from "./modeler-modal-delete-form";
import ModelerModalFormList from "./modeler-modal-form-list";
import FormModeler from "../../../../../containers/smart/camunda/manage-process-page/form-modeler/form-modeler-modal";
import {
  GRID,
  STEPPER,
} from "../../../../../containers/smartForms/components/constants";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";

let listTaskFields = [];

window.jQuery = $;
window.$ = $;
let retSchema = null;

const modelProperties = ["id", "value", "smart"];

function getOrCreateRoot(container) {
  if (!container) return null;
  if (!container.__reactRoot) {
    container.__reactRoot = createRoot(container);
  }
  return container.__reactRoot;
}

function returnschema(schema) {
  retSchema = schema;
}

function getReturnschema(schema) {
  return retSchema;
}

function BuildFormReact(
  itens,
  elementdom,
  returnschema,
  activityName,
  saveForm,
  businessObject,
  element,
  extensionElements,
  selectBox,
  bpmnFactory,
  saveFormOnApi,
  getReturnschema,
  allFormFields,
) {
  const root = getOrCreateRoot(elementdom);
  root.render(
    <Provider>
      <FormModeler
        returnschema={returnschema}
        FormComponents={itens}
        activityName={activityName}
        saveForm={saveForm}
        businessObject={businessObject}
        element={element}
        extensionElements={extensionElements}
        selectBox={selectBox}
        bpmnFactory={bpmnFactory}
        saveFormOnApi={saveFormOnApi}
        getReturnschema={getReturnschema}
        allFormFields={allFormFields}
      />
    </Provider>,
  );
}

function returnsbpmndefinitions(element) {
  if (!element) return;
  if (element.$type === "bpmn:Definitions") return element;
  return returnsbpmndefinitions(element.$parent);
}

function BuildCopyFormReact(
  itens,
  elementdom,
  saveForm,
  businessObject,
  element,
  extensionElements,
  selectBox,
  bpmnFactory,
  xmldata,
  selectedTaskName,
) {
  const root = getOrCreateRoot(elementdom);
  root.render(
    <ModelerModalCopyField
      returnschema={returnschema}
      FormComponents={itens}
      saveForm={saveForm}
      businessObject={businessObject}
      element={element}
      extensionElements={extensionElements}
      selectBox={selectBox}
      bpmnFactory={bpmnFactory}
      xmldata={xmldata}
      selectedTaskName={selectedTaskName}
    />,
  );
}

function BuildFormListModal(
  itens,
  elementdom,
  returnschema,
  activityName,
  saveFormOnSelect,
  businessObject,
  element,
  extensionElements,
  selectBox,
  bpmnFactory,
) {
  const root = getOrCreateRoot(elementdom);
  root.render(
    <Provider>
      <ModelerModalFormList
        returnschema={returnschema}
        FormComponents={itens}
        activityName={activityName}
        saveFormOnSelect={saveFormOnSelect}
        businessObject={businessObject}
        element={element}
        extensionElements={extensionElements}
        selectBox={selectBox}
        bpmnFactory={bpmnFactory}
      />
    </Provider>,
  );
}

function BuildDeleteFormModal(elementdom, handleDelete) {
  const root = getOrCreateRoot(elementdom);
  root.render(<ModelerModalDeleteForm handleDelete={handleDelete} />);
}

// eslint-disable-next-line no-unused-vars
function setDefaultFormKey() {
  const FormKey = document.getElementById("camunda-form-key");

  if (FormKey && FormKey.value.length <= 0) {
    const newId = uuid();
    return `${"Form"}_${newId.substring(0, 6)}`;
  }
  return FormKey.value;
}

function getSelectBox(node, id) {
  const currentTab = domClosest(node, "div.bpp-properties-tab");
  const query =
    "select[name=selectedExtensionElement]" +
    (id ? "[id=cam-extensionElements-" + id + "]" : "");
  return domQuery(query, currentTab);
}

function getSelected(node, id) {
  const selectBox = getSelectBox(node, id);
  return {
    value: (selectBox || {}).value,
    idx: (selectBox || {}).selectedIndex,
  };
}

function generateElementId(prefix) {
  prefix += "_";
  return utils.nextId(prefix);
}

function isExtensionElements(element) {
  return is(element.extensionElements, "bpmn:ExtensionElements");
}

function getElementFields(elements, selectedTaskName) {
  let listexistFields = [];
  forEach(elements, function (elem) {
    let data = null;

    //Armazena os campos do formulário atual para não ser exibido no modal
    if (elem.id === selectedTaskName) {
      if (isExtensionElements(elem)) {
        data = getPropertiesElement(elem.extensionElements);
        if (data && data.fields && data.fields.length > 0) {
          listexistFields = getDetailProps(data.fields, elem.id);
        }
      }
    }
  });
  return listexistFields;
}

function getTaskFields(
  elements,
  selectedTaskName,
  issub = false,
  listAll = false,
) {
  let formfields = [];
  const listexistFields = [];
  if (!issub) {
    listTaskFields = [];
  }

  forEach(elements, function (elem) {
    let data = null;
    if (
      (elem.id !== selectedTaskName || listAll) &&
      (elem.$type === "bpmn:StartEvent" || elem.$type === "bpmn:UserTask")
    ) {
      if (isExtensionElements(elem)) {
        data = getPropertiesElement(elem.extensionElements);

        if (data && data.fields && data.fields.length > 0) {
          const fields = getDetailProps(data.fields, elem.id);
          const listAdd = [];
          for (let i = 0; i < fields.length; i++) {
            // eslint-disable-next-line no-loop-func
            const existField = listexistFields.find(function (f) {
              if (f.id === fields[i].id) {
                return true;
              }
              return false;
            });
            if (!existField) {
              listAdd.push(fields[i]);
              listexistFields.push(fields[i]);
              listTaskFields.push(fields[i]);
            }
            listAdd.push(fields[i]);
            listTaskFields.push(fields[i]);
          }

          const taskform = {
            activityName:
              elem.name && elem.name.length > 0 ? elem.name : elem.id,
            id: elem.id,
            fields: listAdd,
          };
          formfields.push(taskform);
        }
      }
    } else if (elem.$type === "bpmn:SubProcess") {
      const SubProcess = getTaskFields(
        elem.flowElements,
        selectedTaskName,
        true,
        listAll,
      );
      formfields = formfields.concat(SubProcess);
    }
  });
  return formfields;
}

/**
 * Adiciona os campos do grid na visualização do campo "Campos do formulário"
 */
function createAndExtractGridField(
  fieldsInsideGrid,
  formdata,
  selectBox,
  bpmnFactory,
  createOption,
) {
  if (fieldsInsideGrid.length > 0) {
    fieldsInsideGrid.forEach((fg) => {
      if (fg.id) {
        const field = elementHelper.createElement(
          "camunda:FormField",
          {
            id: fg.id,
            type: getCamundaType(
              String(fg.type).toLocaleLowerCase(),
              fg.properties,
            ),
          },
          formdata,
          bpmnFactory,
        );

        field.$parent = formdata;
        formdata.fields.push(field);

        const template = domify(createOption(fg.id));
        selectBox.appendChild(template);
      }
    });
  }
}

function getDetailProps(fields, parentId) {
  const formfields = [];
  let ntype = null;
  let jsondata = {};

  forEach(fields, function (prop) {
    if (
      prop.properties &&
      prop.properties.values &&
      prop.properties.values[0] &&
      prop.properties.values[0].$attrs &&
      prop.properties.values[0].$attrs.smart
    ) {
      jsondata = JSON.parse(prop.properties.values[0].value);
      ntype = jsondata.type;
    } else {
      ntype = null;
      jsondata = {};
    }
    if (ntype === GRID) {
      const griddata = getGridDetails(jsondata, prop.id);
      Array.prototype.push.apply(formfields, griddata);
    }

    const item = {
      id: prop.id,
      label: prop.label,
      parentId,
      type: ntype,
      properties: jsondata,
    };
    formfields.push(item);
  });
  return formfields;
}

function getGridDetails(fields, parentId) {
  const formfields = [];
  for (let linha = 0; linha < fields.items.length; linha++) {
    const rows = fields.items[linha];
    for (let column = 0; column < rows.items.length; column++) {
      const col = rows.items[column];

      for (let content = 0; content < col.items.length; content++) {
        const cont = col.items[content];

        formfields.push({
          id: cont.id,
          label: cont.label,
          parentId,
          type: cont.type,
          properties: cont,
        });
      }
    }
  }
  return formfields;
}

// percorre os itens de um componente Etapa (Stepper) e retorna os campos internos
function getStepperDetails(stepper, parentId) {
  const formfields = [];
  const steps = Array.isArray(stepper.items) ? stepper.items : [];
  for (let s = 0; s < steps.length; s++) {
    const step = steps[s];
    const items = step && Array.isArray(step.items) ? step.items : [];
    for (let i = 0; i < items.length; i++) {
      const cont = items[i];
      if (!cont) continue;
      formfields.push({
        id: cont.id,
        label: cont.label,
        parentId,
        type: cont.type,
        properties: cont,
      });
    }
  }
  return formfields;
}

function getPropertiesElement(element) {
  let data = null;
  forEach(element.values, function (elem) {
    if (elem.$type === "camunda:FormData") {
      data = elem;
    }
  });
  return data;
}

function getCamundaType(propname, properties) {
  let camundaType = "";
  switch (propname) {
    case "date":
      camundaType = propname;
      break;
    case "number":
      if (properties && properties.length > 0) {
        const decimal = properties.find(function (a) {
          return a.id === "decimalSeparator";
        });

        if (decimal) {
          camundaType = "string";
        } else {
          camundaType = "long";
        }
      } else {
        camundaType = "long";
      }
      break;

    case "checkbox":
      camundaType = "boolean";
      break;
    default:
      camundaType = "string";
      break;
  }

  return camundaType;
}

function getMetadatasFromGrid(grid) {
  const metadatas = [];
  for (let linha = 0; linha < grid.items.length; linha++) {
    const rows = grid.items[linha];
    for (let column = 0; column < rows.items.length; column++) {
      const col = rows.items[column];

      for (let content = 0; content < col.items.length; content++) {
        const cont = col.items[content];

        if (cont.isMetadata) {
          metadatas.push({ id: cont.id });
        }
      }
    }
  }
  return metadatas;
}

// percorre os itens de um componente Etapa (Stepper) e retorna seus metadados
function getMetadatasFromStepper(stepper) {
  const metadatas = [];
  const steps = Array.isArray(stepper.items) ? stepper.items : [];
  for (let s = 0; s < steps.length; s++) {
    const step = steps[s];
    const items = step && Array.isArray(step.items) ? step.items : [];
    for (let i = 0; i < items.length; i++) {
      const cont = items[i];
      if (cont && cont.isMetadata) {
        metadatas.push({ id: cont.id });
      }
    }
  }
  return metadatas;
}

const CREATE_EXTENSION_ELEMENT_ACTION = "create-extension-element",
  REMOVE_EXTENSION_ELEMENT_ACTION = "remove-extension-element",
  ORDERUP_EXTENSION_ELEMENT_ACTION = "orderup-extension-element",
  ORDERDOWN_EXTENSION_ELEMENT_ACTION = "orderdown-extension-element";

export default function (element, bpmnFactory, options, translate, modeling) {
  const id = options.id;
  const prefix = options.prefix || "elem",
    label = options.label || id,
    idGeneration = options.idGeneration === false ? options.idGeneration : true;

  let businessObject = options.businessObject || getBusinessObject(element);

  const modelProperty = options.modelProperty || "id";

  const getElements = options.getExtensionElements;

  const createElement = options.createExtensionElement,
    // eslint-disable-next-line no-unused-vars
    canCreate = typeof createElement === "function";

  const removeElement = options.removeExtensionElement,
    // eslint-disable-next-line no-unused-vars
    canRemove = typeof removeElement === "function";

  const onSelectionChange = options.onSelectionChange;

  const hideElements = options.hideExtensionElements,
    canBeHidden = typeof hideElements === "function";

  const setOptionLabelValue = options.setOptionLabelValue;

  const defaultSize = options.size || 5,
    resizable = options.resizable;

  const reference = options.reference || undefined;

  const canOrder = options.canOrder;

  const selectionChanged = function (element, node, event, scope) {
    if (typeof onSelectionChange === "function") {
      return onSelectionChange(element, node, event, scope);
    }
  };

  const createOption = function (value) {
    return (
      '<option value="' +
      escapeHTML(value) +
      '" data-value data-name="extensionElementValue">' +
      escapeHTML(value) +
      "</option>"
    );
  };

  const initSelectionSize = function (selectBox, optionsLength) {
    if (resizable) {
      selectBox.size =
        optionsLength > defaultSize ? optionsLength : defaultSize;
    }
  };

  const saveFormOnApi = function (
    businessObject,
    element,
    extensionElements,
    selectBox,
    bpmnFactory,
    fetchCreateForm,
    fetchEditForm,
    formFields,
    isEdit,
  ) {
    if (retSchema) {
      const components = (retSchema && retSchema.components) || [];

      let metadatas = components
        .filter((m) => {
          return m.isMetadata;
        })
        .map((m) => ({ id: m.id }));
      components.forEach((m) => {
        if (
          m.type &&
          (m.type === "Grid" || (m.type.name && m.type.name === "Grid"))
        ) {
          metadatas = metadatas.concat(getMetadatasFromGrid(m));
        }
        if (
          m.type &&
          (m.type === STEPPER || (m.type.name && m.type.name === STEPPER))
        ) {
          metadatas = metadatas.concat(getMetadatasFromStepper(m));
        }
      });

      const form = {
        id: formFields.id,
        name: formFields.name,
        description: formFields.description,
        category: formFields.category,
        properties: JSON.stringify(components),
        metadatas,
        draft: formFields.draft,
        version: formFields.version,
      };

      if (isEdit) {
        fetchEditForm(form);
      } else {
        fetchCreateForm(form);
      }
    }
  };
  const changeComponentsId = function (fName, items, id) {
    const dInfo = Array.isArray(items.items);
    if (dInfo) {
      for (let i = 0; i < items.items.length; i++) {
        changeComponentsId(fName, items.items[i], id);
      }
    } else if (
      typeof items.items === "object" &&
      Object.prototype.hasOwnProperty.call(items.items, "info")
    ) {
      changeComponentsId(fName, items.items, id);
    } else {
      items.id = (fName + items.id).trim();
      id[0]++;
    }
  };
  const saveForm = function (
    businessObject,
    element,
    extensionElements,
    selectBox,
    bpmnFactory,
    formFields,
  ) {
    if (retSchema) {
      const bo =
        reference && businessObject.get(reference)
          ? businessObject.get(reference)
          : businessObject;

      const components = retSchema && retSchema.components;
      businessObject = businessObject || getBusinessObject(element);
      let AddExtension = false;

      const formValue = formFields;

      // form key form__[activity_id]
      const fName = "form__" + bo.id;

      // contem o id dos campos que estão dentro do grid, será usado apenas para visualização no campo "Campos do formulário"
      const fieldsInsideGrid = [];

      let formdata = null;

      if (components.length > 0) {
        while (selectBox.options.length > 0) {
          selectBox.options.remove(0);
        }
      }
      if (!extensionElements) {
        AddExtension = true;
        extensionElements = elementHelper.createElement(
          "bpmn:ExtensionElements",
          { values: [] },
          businessObject,
          bpmnFactory,
        );
        formdata = elementHelper.createElement(
          "camunda:FormData",
          { fields: [] },
          extensionElements,
          bpmnFactory,
        );
      } else {
        formdata = extensionElements.values.find(function (elem) {
          if (elem.$type === "camunda:FormData") {
            return true;
          }
          return false;
        });

        if (!formdata) {
          formdata = elementHelper.createElement(
            "camunda:FormData",
            { fields: [] },
            extensionElements,
            bpmnFactory,
          );
        }

        if (formdata.fields === undefined) {
          formdata.set("fields", []);
        } else {
          formdata.fields = [];
        }
      }

      for (let idx = 0; idx < components.length; idx++) {
        const formfield = {};
        const properties = [];
        const propertyProps = {};
        /* eslint-disable */
        modelProperties.forEach((prop) => {
          propertyProps[prop] = undefined;
        }); //       let fName = element.form.id + "_v" + element.form.version;
        // components[idx]["id"] =
        //   (fName + "_" + components[idx]["id"]).trim();
        // if (components[idx].type == "Grid") {
        //   let idTemp = [1001];
        //   changeComponentsId(fName + "_", components[idx], idTemp);
        // }

        if (components[idx].type === "Grid") {
          const gridAux = components[idx].items
            ? components[idx]
            : { items: [] };

          fieldsInsideGrid.push(...getGridDetails(gridAux, bo.id));
        }
        
        if (components[idx].type === STEPPER || (components[idx].type && components[idx].type.name === STEPPER)) {
          const stepperAux = components[idx].items ? components[idx] : { items: [] };
          fieldsInsideGrid.push(...getGridDetails(stepperAux, bo.id));
        }

        propertyProps.id = "component";
        propertyProps.value = JSON.stringify(components[idx]);
        propertyProps.smart = true;

        properties.push(
          elementHelper.createElement(
            "camunda:Property",
            propertyProps,
            formdata,
            bpmnFactory,
          ),
        );

        var listprop = Object.keys(components[idx]);
        for (
          var id_taskfield = 0;
          id_taskfield < listprop.length;
          id_taskfield++
        ) {
          var propname = listprop[id_taskfield];

          if (propname === "id") {
            formfield["id"] = components[idx][propname];
          } else if (propname === "properties") {
            formfield[propname] = components[idx][propname];
          } else if (propname === "label") {
            formfield[propname] = components[idx][propname];
          } else if (propname === "value") {
            formfield["defaultValue"] = components[idx][propname];
          } else if (propname === "type") {
            formfield["type"] = getCamundaType(
              components[idx][propname],
              components[idx].properties,
            );
          }
        }

        var field = elementHelper.createElement(
          "camunda:FormField",
          formfield,
          formdata,
          bpmnFactory,
        );
        if (properties.length > 0) {
          var itemproperties = elementHelper.createElement(
            "camunda:Properties",
            { values: properties },
            field,
            bpmnFactory,
          );
          field.set("properties", itemproperties);
        }
        field.$parent = formdata;
        formdata.fields.push(field);

        var template = domify(createOption(field.id));

        // add new empty option as last child element
        selectBox.appendChild(template);
      }

      createAndExtractGridField(
        fieldsInsideGrid,
        formdata,
        selectBox,
        bpmnFactory,
        createOption,
      );

      // atualizando o formData do extensionElements para evitar que outras configurações da task sejam perdidas
      var formDataIndex = extensionElements.values.findIndex(function (elem) {
        if (elem.$type === "camunda:FormData") {
          return true;
        }
        return false;
      });

      if (formDataIndex !== -1) {
        extensionElements.values[formDataIndex] = formdata;
      } else {
        extensionElements.values.push(formdata);
      }

      bo.set("extensionElements", extensionElements);

      // update select box size
      initSelectionSize(selectBox, selectBox.options.length);
      bo.set("formKey", fName);

      modeling.updateProperties(element, {});

      const hasCopyButton = checkCopyData();

      if (checkItens()) {
        // botão editar
        document.getElementById(
          "cam-extensionElements-formbuilder-" + escapeHTML(id),
        ).innerHTML = "<span>" + translate("Edit") + "</span>";

        // botão copiar
        if (hasCopyButton) {
          document.getElementById(
            "cam-extensionElements-copy-" + escapeHTML(id),
          ).style.display = "block";
        } else {
          document.getElementById(
            "cam-extensionElements-copy-" + escapeHTML(id),
          ).style.display = "none";
        }

        // botão excluir
        document.getElementById(
          "cam-extensionElements-delete-" + escapeHTML(id),
        ).style.display = "block";
      } else {
        // botão adicionar
        document.getElementById(
          "cam-extensionElements-formbuilder-" + escapeHTML(id),
        ).innerHTML = "<span>" + translate("Add Form") + "</span>";

        if (hasCopyButton) {
          document.getElementById(
            "cam-extensionElements-copy-" + escapeHTML(id),
          ).style.display = "block";
        } else {
          document.getElementById(
            "cam-extensionElements-copy-" + escapeHTML(id),
          ).style.display = "none";
        }

        document.getElementById(
          "cam-extensionElements-delete-" + escapeHTML(id),
        ).style.display = "none";
      }
    }
  };

  var copForm = function (
    businessObject,
    element,
    extensionElements,
    selectBox,
    bpmnFactory,
    selectItens,
  ) {
    var currentlist = selectItens;
    businessObject = businessObject || getBusinessObject(element);
    var bo =
      reference && businessObject.get(reference)
        ? businessObject.get(reference)
        : businessObject;
    var AddExtension = false;
    extensionElements = bo.get("extensionElements");
    var formdata = null;

    const fName = "form__" + bo.id;

    // contem o id dos campos que estão dentro do grid, será usado apenas para visualização no campo "Campos do formulário"
    let fieldsInsideGrid = [];

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        { values: [] },
        businessObject,
        bpmnFactory,
      );
      formdata = elementHelper.createElement(
        "camunda:FormData",
        { fields: [] },
        extensionElements,
        bpmnFactory,
      );
    } else {
      formdata = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:FormData") {
          return true;
        } else return false;
      });

      if (!formdata) {
        formdata = elementHelper.createElement(
          "camunda:FormData",
          { fields: [] },
          extensionElements,
          bpmnFactory,
        );
      }

      if (formdata.fields === undefined) {
        formdata.set("fields", []);
      }
    }
    for (var idx = 0; idx < currentlist.length; idx++) {
      if (currentlist[idx].checked) {
        var formfield = {};
        var properties = [];
        var originField = listTaskFields.find(function (a) {
          /* eslint-disable */
          return (
            a.parentId === currentlist[idx].parentId &&
            a.id === currentlist[idx].id
          );
        });

        if (originField) {
          if (originField.type === "Grid") {
            const gridAux =
              originField.properties && originField.properties.items
                ? originField.properties
                : { items: [] };

            fieldsInsideGrid.push(...getGridDetails(gridAux, bo.id));
          }

          var listprop = Object.keys(originField);
          for (
            var id_taskfield = 0;
            id_taskfield < listprop.length;
            id_taskfield++
          ) {
            var prop = listprop[id_taskfield];
            if (prop === "properties") {
              var propertyProps = {
                id: "component",
                value: JSON.stringify(originField[prop]),
                smart: "true",
              };
              properties.push(
                elementHelper.createElement(
                  "camunda:Property",
                  propertyProps,
                  formdata,
                  bpmnFactory,
                ),
              );
            } else if (prop === "type") {
              formfield[prop] = getCamundaType(
                originField[prop],
                originField["properties"],
              );
            } else if (prop !== "parentId") {
              formfield[prop] = originField[prop];
            }
          }
        }

        var field = elementHelper.createElement(
          "camunda:FormField",
          formfield,
          formdata,
          bpmnFactory,
        );
        if (properties.length > 0) {
          var itemproperties = elementHelper.createElement(
            "camunda:Properties",
            { values: properties },
            field,
            bpmnFactory,
          );
          field.set("properties", itemproperties);
        }
        field.$parent = formdata;
        formdata.fields.push(field);

        var template = domify(createOption(field.id));

        // add new empty option as last child element
        selectBox.appendChild(template);
      }
    }

    createAndExtractGridField(
      fieldsInsideGrid,
      formdata,
      selectBox,
      bpmnFactory,
      createOption,
    );

    var formDataIndex = extensionElements.values.findIndex(function (elem) {
      if (elem.$type === "camunda:FormData") {
        return true;
      }
      return false;
    });

    if (formDataIndex !== -1) {
      extensionElements.values[formDataIndex] = formdata;
    } else {
      extensionElements.values.push(formdata);
    }

    bo.set("extensionElements", extensionElements);

    // update select box size
    initSelectionSize(selectBox, selectBox.options.length);

    bo.set("formKey", fName);

    modeling.updateProperties(element, {});

    const hasCopyButton = checkCopyData();

    if (checkItens()) {
      // botão editar
      document.getElementById(
        "cam-extensionElements-formbuilder-" + escapeHTML(id),
      ).innerHTML = "<span>" + translate("Edit") + "</span>";

      // botão copiar
      if (hasCopyButton) {
        
        document.getElementById(
          "cam-extensionElements-copy-" + escapeHTML(id),
        ).style.display = "block";
      } else {
        document.getElementById(
          "cam-extensionElements-copy-" + escapeHTML(id),
        ).style.display = "none";
      }

      // botão excluir
      document.getElementById(
        "cam-extensionElements-delete-" + escapeHTML(id),
      ).style.display = "block";
    } else {
      // botão adicionar
      document.getElementById(
        "cam-extensionElements-formbuilder-" + escapeHTML(id),
      ).innerHTML = "<span>" + translate("Add Form") + "</span>";

      if (hasCopyButton) {
        document.getElementById(
          "cam-extensionElements-copy-" + escapeHTML(id),
        ).style.display = "block";
      } else {
        document.getElementById(
          "cam-extensionElements-copy-" + escapeHTML(id),
        ).style.display = "none";
      }

      document.getElementById(
        "cam-extensionElements-delete-" + escapeHTML(id),
      ).style.display = "none";
    }
  };

  var saveFormOnSelect = function (
    businessObject,
    element,
    extensionElements,
    selectBox,
    bpmnFactory,
    formProperties,
  ) {
    var bo =
      reference && businessObject.get(reference)
        ? businessObject.get(reference)
        : businessObject;

    //var components = retSchema && retSchema.components;
    businessObject = businessObject || getBusinessObject(element);
    var AddExtension = false;

    // form key form__[activity_id]
    const fName = "form__" + bo.id;

    // contem o id dos campos que estão dentro do grid, será usado apenas para visualização no campo "Campos do formulário"
    let fieldsInsideGrid = [];

    let prevFields = [];
    let existentIdsAndUuids = {};

    // form anterior
    var extensionElementsPrev = bo.get("extensionElements");
    if (extensionElementsPrev) {
      var formdataPrev = extensionElementsPrev.values.find(function (elem) {
        if (elem.$type === "camunda:FormData") {
          return true;
        } else return false;
      });

      if (formdataPrev && formdataPrev.fields.length > 0) {
        prevFields.unshift(...formdataPrev.fields);
      }
    }

    // armazenando o id e uuid dos campos existentes para garantir que não haverá campos duplicados
    prevFields.forEach((f) => {
      existentIdsAndUuids[f.id] = f.id;
      existentIdsAndUuids[f.uuid] = f.uuid;
    });

    var formdata = null;
    if (formProperties && formProperties.length > 0) {
      while (selectBox.options.length > 0) {
        selectBox.options.remove(0);
      }
    }

    if (!extensionElements) {
      AddExtension = true;
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        { values: [] },
        businessObject,
        bpmnFactory,
      );
      formdata = elementHelper.createElement(
        "camunda:FormData",
        { fields: [] },
        extensionElements,
        bpmnFactory,
      );
    } else {
      formdata = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:FormData") {
          return true;
        } else return false;
      });

      if (!formdata) {
        formdata = elementHelper.createElement(
          "camunda:FormData",
          { fields: [] },
          extensionElements,
          bpmnFactory,
        );
      }
      if (formdata.fields === undefined) {
        formdata.set("fields", []);
      } else {
        formdata.fields = [];
      }
    }

    if (prevFields.length > 0) {
      prevFields.forEach((f) => {
        f.$parent = formdata;
        formdata.fields.push(f);

        var template = domify(createOption(f.id));

        // add new empty option as last child element
        selectBox.appendChild(template);
      });
    }

    if (formProperties && formProperties.length > 0) {
      formProperties.forEach((element) => {
        element.form.properties = JSON.parse(element.form.properties);
        for (var idx = 0; idx < element.form.properties.length; idx++) {
          // verifica se ja existem um campo com o mesmo "id" ou "uuid"
          if (
            existentIdsAndUuids[element.form.properties[idx]["id"]] ||
            existentIdsAndUuids[element.form.properties[idx]["uuid"]]
          ) {
            continue;
          }

          if (element.form.properties[idx]["type"] === "Grid") {
            const gridAux = element.form.properties[idx]["items"]
              ? element.form.properties[idx]
              : { items: [] };

            fieldsInsideGrid.push(...getGridDetails(gridAux, bo.id));
          }

          var formfield = {};
          var properties = [];
          var propertyProps = {};

          /* eslint-disable */
          modelProperties.forEach((prop) => {
            propertyProps[prop] = undefined;
          });

          propertyProps.id = "component";
          propertyProps.value = JSON.stringify(element.form.properties[idx]);
          propertyProps.smart = true;
          properties.push(
            elementHelper.createElement(
              "camunda:Property",
              propertyProps,
              formdata,
              bpmnFactory,
            ),
          );

          var listprop = Object.keys(element.form.properties[idx]);
          for (
            var id_taskfield = 0;
            id_taskfield < listprop.length;
            id_taskfield++
          ) {
            var propname = listprop[id_taskfield];

            if (propname === "id") {
              formfield["id"] = element.form.properties[idx][propname];
            } else if (propname === "properties") {
              formfield[propname] = element.form.properties[idx][propname];
            } else if (propname === "label") {
              formfield[propname] = element.form.properties[idx][propname];
            } else if (propname === "value") {
              formfield["defaultValue"] =
                element.form.properties[idx][propname];
            } else if (propname === "type") {
              formfield["type"] = getCamundaType(
                element.form.properties[idx][propname],
                element.form.properties[idx].properties,
              );
            }
          }

          var field = elementHelper.createElement(
            "camunda:FormField",
            formfield,
            formdata,
            bpmnFactory,
          );
          if (properties.length > 0) {
            var itemproperties = elementHelper.createElement(
              "camunda:Properties",
              { values: properties },
              field,
              bpmnFactory,
            );
            field.set("properties", itemproperties);
          }
          field.$parent = formdata;
          formdata.fields.push(field);

          var template = domify(createOption(field.id));

          // add new empty option as last child element
          selectBox.appendChild(template);
        }

        createAndExtractGridField(
          fieldsInsideGrid,
          formdata,
          selectBox,
          bpmnFactory,
          createOption,
        );

        var formDataIndex = extensionElements.values.findIndex(function (elem) {
          if (elem.$type === "camunda:FormData") {
            return true;
          }
          return false;
        });

        if (formDataIndex !== -1) {
          extensionElements.values[formDataIndex] = formdata;
        } else {
          extensionElements.values.push(formdata);
        }

        bo.set("extensionElements", extensionElements);
      });
    }

    bo.set("formKey", fName);

    const hasCopyButton = checkCopyData();

    if (checkItens()) {
      document.getElementById(
        "cam-extensionElements-formbuilder-" + escapeHTML(id),
      ).innerHTML = "<span>" + translate("Edit") + "</span>";

      // botão copiar
      if (hasCopyButton) {
        document.getElementById(
          "cam-extensionElements-copy-" + escapeHTML(id),
        ).style.display = "block";
      } else {
        document.getElementById(
          "cam-extensionElements-copy-" + escapeHTML(id),
        ).style.display = "none";
      }

      document.getElementById(
        "cam-extensionElements-delete-" + escapeHTML(id),
      ).style.display = "block";
    } else {
      document.getElementById(
        "cam-extensionElements-formbuilder-" + escapeHTML(id),
      ).innerHTML = "<span>" + translate("Add Form") + "</span>";

      // botão copiar
      if (hasCopyButton) {
        document.getElementById(
          "cam-extensionElements-copy-" + escapeHTML(id),
        ).style.display = "block";
      } else {
        document.getElementById(
          "cam-extensionElements-copy-" + escapeHTML(id),
        ).style.display = "none";
      }

      document.getElementById(
        "cam-extensionElements-delete-" + escapeHTML(id),
      ).style.display = "none";
    }

    // update select box size
    initSelectionSize(selectBox, selectBox.options.length);

    modeling.updateProperties(element, {});
  };

  const checkItens = function () {
    let have = false;
    businessObject = businessObject || getBusinessObject(element);

    let bo =
      reference && businessObject.get(reference)
        ? businessObject.get(reference)
        : businessObject;

    let extensionElements = bo.get("extensionElements");
    if (extensionElements?.values[0]?.fields?.length === 0) {
      extensionElements = undefined;
    }
    if (extensionElements) {
      extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:FormData") {
          have = Boolean(elem.fields.length);
        }
      });
    }
    return have;
  };

  var checkCopyData = function () {
    var haveCopy = false;
    var bo =
      reference && businessObject.get(reference)
        ? businessObject.get(reference)
        : businessObject;

    var xmldata = null;

    var bpmnDefinitions = returnsbpmndefinitions(bo);

    if (bpmnDefinitions && bpmnDefinitions.rootElements) {
      var rootElements = bpmnDefinitions.rootElements.find(function (elem) {
        if (elem.$type === "bpmn:Process") {
          return true;
        } else return false;
      });

      var fields = getElementFields(
        rootElements.flowElements,
        businessObject.id,
      );
      var formfields = getTaskFields(
        rootElements.flowElements,
        businessObject.id,
      );

      if (formfields.length > 0) {
        haveCopy = true;
      }
    }

    return haveCopy;
  };

  const deleteForm = function (element, node) {
    var selectBox = getSelectBox(node, id);
    var total = selectBox.options.length;
    for (let loop = total - 1; loop > -1; loop--) {
      selectBox.options.remove(0);
    }

    // update select box size
    initSelectionSize(selectBox, selectBox.options.length);
    var dataelement = getBusinessObject(element);
    dataelement.extensionElements.values = filter(
      dataelement.extensionElements.values,
      function (elem) {
        return elem.$type !== "camunda:FormData";
      },
    );

    modeling.updateProperties(element, {});
    $("#cam-extensionElements-formbuilder-form-fields").html(
      translate("Add Form"),
    );

    document.getElementById(
      "cam-extensionElements-delete-" + escapeHTML(id),
    ).style.display = "none";
    return true;
  };

  return {
    id: id,
    html:
      "<style>" +
      ".btn { border: 2px solid black; background-color: white; color: black; padding: 14px 28px; font-size: 16px; cursor: pointer; } " +
      ".err {border-color: #900020;color: #900020;}" +
      ".err:hover {background: #900020;color: white;}" +
      ".info {border-color: #000A69;color: dodgerblue;}" +
      ".info:hover {background: #000A69;color: white;}</style>" +
      '<div class="bpp-row bpp-element-list" ' +
      (canBeHidden ? 'data-show="hideElements"' : "") +
      ">" +
      '<label for="cam-extensionElements-' +
      escapeHTML(id) +
      '">' +
      escapeHTML(label) +
      "</label>" +
      '<div class="bpp-field-wrapper">' +
      '<select id="cam-extensionElements-' +
      escapeHTML(id) +
      '"' +
      'name="selectedExtensionElement" ' +
      'size="' +
      escapeHTML(defaultSize) +
      '" ' +
      "data-list-entry-container " +
      'data-on-change="selectElement">' +
      "</select>" +
      (canOrder &&
        "<button " +
          'id="cam-extensionElements-formbuilder-' +
          escapeHTML(id) +
          '" ' +
          'data-action="formbuilder" ' +
          'class="btn info"' +
          'style="display: block; width: 100%;  margin-top:3px; margin-bottom:3px;" ' +
          'data-disable="disableOrder">' +
          "<span>" +
          (checkItens() ? translate("Edit") : translate("Add Form")) +
          "</span>" +
          "</button>") +
      (canOrder &&
        '<button " ' +
          'id="cam-extensionElements-copy-' +
          escapeHTML(id) +
          '" ' +
          'data-action="copy" ' +
          'class="btn info"' +
          'style="display:' +
          (checkCopyData() ? "block;" : "none;") +
          'width: 100%; margin-bottom:3px;"' +
          'data-disable="disableOrder">' +
          "<span>" +
          translate("Copy") +
          "</span>" +
          "</button>") +
      (canOrder &&
        '<button " ' +
          'id="cam-extensionElements-delete-' +
          escapeHTML(id) +
          '" ' +
          'data-action="delete" ' +
          'class="btn err"' +
          'style="display:' +
          (checkItens() ? "block;" : "none;") +
          'width: 100%; margin-bottom:3px;"' +
          'data-disable="disableOrder">' +
          "<span>" +
          translate("Delete") +
          "</span>" +
          "</button>") +
      (canOrder
        ? "<button " +
          'id="cam-extensionElements-formList-' +
          escapeHTML(id) +
          '" ' +
          'data-action="formList" ' +
          'class="btn info" ' +
          'style="display: block; width: 100%;  margin-top:3px; margin-bottom:3px;" ' +
          'data-disable="disableOrder">' +
          '<span">' +
          language.selectForm +
          "</span>" +
          "</button>"
        : "") +
      "</div>" +
      "</div>",

    get: function (element, node) {
      var elements = getElements(element, node);

      var result = [];
      forEach(elements, function (elem) {
        result.push({
          extensionElementValue: elem.get(modelProperty),
        });
      });

      var selectBox = getSelectBox(node.parentNode, id);
      initSelectionSize(selectBox, result.length);

      return result;
    },

    set: function (element, values, node) {
      var action = this.__action;
      delete this.__action;

      businessObject = businessObject || getBusinessObject(element);

      var bo =
        reference && businessObject.get(reference)
          ? businessObject.get(reference)
          : businessObject;

      var extensionElements = bo.get("extensionElements");

      if (action.id === CREATE_EXTENSION_ELEMENT_ACTION) {
        var commands = [];
        if (!extensionElements) {
          extensionElements = elementHelper.createElement(
            "bpmn:ExtensionElements",
            { values: [] },
            bo,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.updateBusinessObject(element, bo, {
              extensionElements: extensionElements,
            }),
          );
        }
        commands.push(
          createElement(element, extensionElements, action.value, node),
        );
        return commands;
      } else if (action.id === REMOVE_EXTENSION_ELEMENT_ACTION) {
        return removeElement(
          element,
          extensionElements,
          action.value,
          action.idx,
          node,
        );
      }
    },

    createListEntryTemplate: function (value, index, selectBox) {
      initSelectionSize(selectBox, selectBox.options.length + 1);
      return createOption(value.extensionElementValue);
    },

    deselect: function (element, node) {
      var selectBox = getSelectBox(node, id);
      selectBox.selectedIndex = -1;
    },

    getSelected: function (element, node) {
      return getSelected(node, id);
    },

    setControlValue: function (element, node, option, property, value, idx) {
      node.value = value;

      if (!setOptionLabelValue) {
        node.text = value;
      } else {
        setOptionLabelValue(element, node, option, property, value, idx);
      }
    },

    createElement: function (element, node) {
      // create option template
      var generatedId;
      if (idGeneration) {
        generatedId = generateElementId(prefix);
      }

      var selectBox = getSelectBox(node, id);
      var template = domify(createOption(generatedId));

      // add new empty option as last child element
      selectBox.appendChild(template);

      // select last child element
      selectBox.lastChild.selected = "selected";
      selectionChanged(element, node);

      // update select box size
      initSelectionSize(selectBox, selectBox.options.length);

      this.__action = {
        id: CREATE_EXTENSION_ELEMENT_ACTION,
        value: generatedId,
      };

      return true;
    },

    removeElement: function (element, node) {
      var selection = getSelected(node, id);

      var selectBox = getSelectBox(node, id);
      selectBox.removeChild(selectBox.options[selection.idx]);

      // update select box size
      initSelectionSize(selectBox, selectBox.options.length);

      this.__action = {
        id: REMOVE_EXTENSION_ELEMENT_ACTION,
        value: selection.value,
        idx: selection.idx,
      };

      return true;
    },

    hideElements: function (element, entryNode, node, scopeNode) {
      return !hideElements(element, entryNode, node, scopeNode);
    },

    disableRemove: function (element, entryNode, node, scopeNode) {
      return (getSelected(entryNode, id) || {}).idx < 0;
    },
    orderdown: function (element, node) {
      var selection = getSelected(node, id);

      var selectBox = getSelectBox(node, id);

      if (selectBox.options.length === 0) {
        return;
      }

      businessObject = businessObject || getBusinessObject(element);

      var bo =
        reference && businessObject.get(reference)
          ? businessObject.get(reference)
          : businessObject;

      var extensionElements = bo.get("extensionElements");
      var formdata = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:FormData") {
          return true;
        } else return false;
      });

      var from = selection.idx;
      var to = selection.idx + 1;

      if (to > formdata.fields.length - 1) {
        return false;
      } else {
        var fromOption = new Option(
          selectBox.options[from].text,
          selectBox.options[from].value,
        );
        var toOption = new Option(
          selectBox.options[to].text,
          selectBox.options[to].value,
        );

        formdata.fields.splice(to, 0, formdata.fields.splice(from, 1)[0]);
        selectBox.options[to] = fromOption;
        selectBox.options[from] = toOption;

        selectBox.options[to].selected = "selected";
        selectionChanged(element, node);

        this.__action = {
          id: ORDERDOWN_EXTENSION_ELEMENT_ACTION,
          value: selection.value,
          idx: to,
        };
      }

      return true;
    },
    orderup: function (element, node) {
      var selection = getSelected(node, id);
      var selectBox = getSelectBox(node, id);

      businessObject = businessObject || getBusinessObject(element);

      if (selectBox.options.length === 0) {
        return;
      }

      var bo =
        reference && businessObject.get(reference)
          ? businessObject.get(reference)
          : businessObject;

      var extensionElements = bo.get("extensionElements");
      var formdata = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:FormData") {
          return true;
        } else return false;
      });

      var from = selection.idx;
      var to = selection.idx - 1;

      if (to < 0) {
        return false;
      } else {
        var fromOption = new Option(
          selectBox.options[from].text,
          selectBox.options[from].value,
        );
        var toOption = new Option(
          selectBox.options[to].text,
          selectBox.options[to].value,
        );

        formdata.fields.splice(to, 0, formdata.fields.splice(from, 1)[0]);
        selectBox.options[to] = fromOption;
        selectBox.options[from] = toOption;

        selectBox.options[to].selected = "selected";
        selectionChanged(element, node);

        this.__action = {
          id: ORDERUP_EXTENSION_ELEMENT_ACTION,
          value: selection.value,
          idx: to,
        };
      }
      return true;
    },
    formbuilder: function (element, node) {
      businessObject = businessObject || getBusinessObject(element);
      var selectBox = getSelectBox(node, id);
      var FormComponents = [];
      var bo =
        reference && businessObject.get(reference)
          ? businessObject.get(reference)
          : businessObject;

      var modelerbuilder = document.createElement("modelerbuilder2");

      var extensionElements = bo.get("extensionElements");
      if (extensionElements) {
        var formdata = extensionElements.values.find(function (elem) {
          if (elem.$type === "camunda:FormData") {
            return true;
          } else return false;
        });

        if (formdata && formdata.fields) {
          for (
            var idxfield = 0;
            idxfield < formdata.fields.length;
            idxfield++
          ) {
            var fieldProperties = formdata.fields[idxfield].properties
              ? formdata.fields[idxfield].properties.values
              : [];
            forEach(fieldProperties, function () {
              if (fieldProperties[0].id === "component") {
                var fielddata = fieldProperties[0].value
                  .replace(/&#34;/g, '"')
                  .replace(/&#39;/g, "'")
                  .replace(/&#38;/g, "&");
                FormComponents.push(JSON.parse(fielddata));
              }
            });
          }
        }
      }

      var activityName = bo.name ? bo.name : bo.id;

      var bpmnDefinitions = returnsbpmndefinitions(bo);

      let formfields = [];
      if (bpmnDefinitions && bpmnDefinitions.rootElements) {
        var rootElements = bpmnDefinitions.rootElements.find(function (elem) {
          if (elem.$type === "bpmn:Process") {
            return true;
          } else return false;
        });

        const allFormfields = getTaskFields(
          rootElements.flowElements,
          businessObject.id,
          false,
          true,
        );

        formfields = allFormfields
          .reduce((prev, current) => {
            if (current && current.fields && current.fields.length > 0) {
              return prev.concat(current.fields);
            }
            return prev;
          }, [])
          .filter((value, index, self) => {
            return index === self.findIndex((obj) => obj.id === value.id);
          });
      }

      BuildFormReact(
        FormComponents,
        modelerbuilder,
        returnschema,
        activityName,
        saveForm,
        businessObject,
        element,
        extensionElements,
        selectBox,
        bpmnFactory,
        saveFormOnApi,
        getReturnschema,
        formfields,
      );
    },
    copy: function (element, node) {
      businessObject = businessObject || getBusinessObject(element);
      var selectBox = getSelectBox(node, id);
      var bo =
        reference && businessObject.get(reference)
          ? businessObject.get(reference)
          : businessObject;

      var xmldata = null;

      var bpmnDefinitions = returnsbpmndefinitions(bo);
      bpmnFactory._model
        .toXML(bpmnDefinitions, { format: false })
        .then((result) => {
          xmldata = result.xml;
          var rootElements = bpmnDefinitions.rootElements.find(function (elem) {
            if (elem.$type === "bpmn:Process") {
              return true;
            } else return false;
          });
          var fields = getElementFields(
            rootElements.flowElements,
            businessObject.id,
          );
          getTaskFields(rootElements.flowElements, businessObject.id);
          var extensionElements = bo.get("definitions");
          var modelercopyForm = document.createElement("modelercopyForm");
          BuildCopyFormReact(
            fields,
            modelercopyForm,
            copForm,
            businessObject,
            element,
            extensionElements,
            selectBox,
            bpmnFactory,
            xmldata,
            businessObject.id,
          );
        });
    },
    formList: function (element, node) {
      businessObject = businessObject || getBusinessObject(element);
      var selectBox = getSelectBox(node, id);
      var FormComponents = [];
      var bo =
        reference && businessObject.get(reference)
          ? businessObject.get(reference)
          : businessObject;

      var modelerModalFormList = document.createElement("modelerformList");

      var extensionElements = bo.get("extensionElements");
      var formsKeys = bo.get("formKey");
      FormComponents = formsKeys ? formsKeys.split(", ") : [];
      var activityName = bo.name ? bo.name : bo.id;

      BuildFormListModal(
        FormComponents,
        modelerModalFormList,
        returnschema,
        activityName,
        saveFormOnSelect,
        businessObject,
        element,
        extensionElements,
        selectBox,
        bpmnFactory,
      );
    },

    delete: function (element, node) {
      var modelerModalDeleteForm = document.createElement("modelerdeleteForm");

      BuildDeleteFormModal(modelerModalDeleteForm, () =>
        deleteForm(element, node),
      );
    },

    selectElement: selectionChanged,
  };
}
